import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: 'Next month', value: 'nextMonth'},
    {label: 'Next 3 months', value: 'next3Month'},
    {label: 'Next 6 months', value: 'next6Month'},
    {label: 'Next year', value: 'nextYear'},
    {label: 'Custom Date', value: 'custom'}
]

const PREV_OPTIONS = [
    {label: 'Previous Period', value: 'previous'},
    {label: 'Custom Date', value: 'custom'}
]

export default function SelectLaterRange({previous=false, ...props}) {

    const myProps = {
        label: 'Next Period',
        options: !previous ? OPTIONS : PREV_OPTIONS,
        isClearable: false, firstSelect: false, isMulti: false,
        icon: {icon: 'calendar'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}